import { render } from "./Renderer.vue?vue&type=template&id=10142e6c"
import script from "./Renderer.vue?vue&type=script&lang=ts"
export * from "./Renderer.vue?vue&type=script&lang=ts"
script.render = render

export default script